import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { en, de } from 'vuetify/locale';

import '@mdi/font/css/materialdesignicons.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';

const themeColors = {
	primary: '#28ABB5',
	'primary-dark': '#0E6167',
	'primary-light': '#51D5DB',
	'primary-background': '#EAF1F1',
	secondary: '#E91E63',
	'secondary-dark': '#BE134D',
	'secondary-light': '#F06191',
	'secondary-background': '#E9EBEC',
	accent: '#CD2367',
	'accent-dark': '#9E124A',
	'accent-light': '#81C784',
	'accent-background': '#E9EBEC',
	error: '#F44336',
	'error-dark': '#D32F2F',
	'error-light': '#E57373',
	'error-text': '#611A15',
	'error-background': '#FDECEB',
	info: '#2196F3',
	'info-dark': '#0B79D0',
	'info-light': '#BBDEFB',
	'info-text': '#0D3C61',
	'info-background': '#E9F4FD',
	success: '#4CAF50',
	'success-dark': '#388E3C',
	'success-light': '#81C784',
	'success-text': '#1E4620',
	'success-background': '#ECF5EC',
	warning: '#FF9800',
	'warning-dark': '#F57C00',
	'warning-darken3': '#E09C32',
	'warning-light': '#FFB74D',
	'warning-text': '#663C00',
	'warning-background': '#FFF4E6',
	'warning-background-dark': '#FCD8A9',
	'grey-50': '#FAFAFA',
	'grey-100': '#F5F5F5',
	'grey-200': '#EEEEEE',
	'grey-300': '#E0E0E0',
	'grey-400': '#BDBDBD',
	'grey-500': '#9E9E9E',
	'grey-600': '#757575',
	'grey-700': '#616161',
	'grey-800': '#424242',
	'grey-900': '#212121',
	'grey-a100': '#D5D5D5',
	'grey-a200': '#AAAAAA',
	'grey-a400': '#616161',
	'grey-a700': '#303030',
	'text-primary': '#1F1F1F',
	'text-secondary': '#707070',
	'text-disabled': '#979797',
	'text-hint': '#979797',
	'text-contrast': '#FFFFFF',
	'action-active': '#707070',
	'action-hover': '#EBEBEB',
	'action-selected': '#E1E1E1',
	'action-disabled': '#B5B5B5',
	'action-disabled-background': '#D7D7D7',
	'action-focus': '#D7D7D7',
	'misc-black': '#000000',
	'misc-white': '#FFFFFF',
	'misc-background-paper': '#FFFFFF',
	'misc-background-default': '#FAFAFA',
	'misc-divider': '#D7D7D7',
	'misc-backdrop': '#7A7A7A',
	'misc-filled-input': '#DEDEDE',
	'misc-tooltip': '#6F6F6F',
	'misc-snackbar': '#323232',
	'misc-rating': '#FFB400',
	'cyan-green': '#00FF80',
	'primary-green': '#3c573e',
	'indigo-lighten-5': '#6779e4',
};

const locale = localStorage.getItem('locale');
let shortLocale;
if (locale) {
	shortLocale = locale.substring(0, 2);
}

export default createVuetify({
	theme: {
		defaultTheme: 'light',
		themes: {
			light: {
				dark: false,
				colors: themeColors,
				variables: {
					'disabled-opacity': 0.55,
				},
			},
			dark: {
				dark: true,
				colors: themeColors,
				variables: {
					'disabled-opacity': 0.85,
				},
			},
		},
	},
	locale: {
		locale: shortLocale || 'de',
		fallback: 'en',
		messages: { de, en },
	},
});
